import SharedSupportTicket from "../../default/components/SupportTicket";

const SupportTicket = (props) => {
    return <SharedSupportTicket variant="hr-support" {...props} />;
};

export default SupportTicket;